import { PointerLockControls, ScrollControls, Environment, Scroll, useScroll } from '@react-three/drei'
import { useEffect } from "react"
import { mainStore } from "./store"

import { useFrame } from '@react-three/fiber'
import { useControls } from 'leva'
import { Perf } from 'r3f-perf'
import { Suspense } from 'react'
import HeadChapterOne from './chapters/one/Head.jsx'
import BodyChapterOne from './chapters/one/Body.jsx'

import { __ } from './utils.js'
import HeadChapterTwo from './chapters/two/Head.jsx'
import BodyChapterTwo from './chapters/two/Body.jsx'
import BodyChapterThree from './chapters/three/Body.jsx'
import HeadChapterThree from './chapters/three/Head.jsx'
import HeadChapterFour from './chapters/four/Head.jsx'
import BodyChapterFour from './chapters/four/Body.jsx'
import ScrollListener from './components/interface/ScrollListener.jsx'
import HeadChapterFive from './chapters/five/Head.jsx'
import BodyChapterFive from './chapters/five/Body.jsx'

import TextCenter from "./components/textCenter.jsx"
import Outro from './components/Outro.jsx'





export default function Experience() {

    /**
     * Setup
     */

    // Lang
    if (window.location.pathname.includes('fr')) mainStore.setLang('fr')
    const lang = mainStore.useStore(s => s.lang)

    // Chapter
    const current = mainStore.useStore(s => s.current)
    const damping = mainStore.useStore(s => s.damping)

    const additionnalPage = mainStore.useStore(s => s.additionnalPage)


    /**
    * Debug
    */

    // Tweaks
    const { perfVisible } = useControls('Experience', {
        perfVisible: false
    })

    const colors = useControls('Colors', mainStore.useStore(s => s.colors))


    useEffect(() => {

        console.log('Experience mounted...')

        console.log('Detected language : ' + lang)


    }, [])

    useFrame((state, delta) => {

        state.camera.rotation.y = 0 - state.mouse.x * 0.009
        state.camera.position.x = 0 - state.mouse.x * 0.025

    })

    return <>

        {perfVisible && <Perf position="top-left" />}

        <Environment preset='city' environmentIntensity={0.8} ></Environment>

        <ambientLight intensity={1} />

        <color args={[colors.clear]} attach="background" />

        <ScrollControls damping={damping} pages={27.1 + additionnalPage}>
            <Scroll>
                <ScrollListener />
                <Suspense>
                    <HeadChapterOne />
                    <BodyChapterOne />
                </Suspense>
                <Suspense>
                    <HeadChapterTwo />
                    <BodyChapterTwo />
                </Suspense>
                <Suspense>
                    <HeadChapterThree />
                    <BodyChapterThree />
                </Suspense>
                <Suspense>
                    <HeadChapterFour />
                    <BodyChapterFour />
                </Suspense>
                <Suspense>
                    <HeadChapterFive />
                    <BodyChapterFive />
                </Suspense>
                <Outro />
            </Scroll>
        </ScrollControls>



    </>
}